/**
 * The text that goes on a Longitude Study line.
 *
 * Kept out of the dialog deliberately. `LongitudeStudyDlg` imports `AuthContext`, which imports
 * axios, which ships as ESM and cannot be loaded by this project's Jest transform — so anything
 * exported from the dialog is untestable without mounting the whole auth stack. The label rules
 * are pure string logic and belong somewhere they can be asserted directly.
 */

/**
 * The short frame name for a study line.
 *
 * <b>Only the observer's position, not the zodiac.</b> This study measures the SEPARATION between
 * two bodies, and the ayanamsha is a constant offset subtracted from both longitudes — so `a - b`
 * is identical whether the longitudes are read tropically or siderally. There is no
 * sidereal/tropical control in the dialog for that reason, and printing "Sid" or "Trop" here
 * would claim a distinction the arithmetic cannot make. (The retrograde studies dropped their
 * frame dropdown on exactly this argument: a control that cannot change the answer misleads.)
 *
 * Unknown falls back to Geo, which is also the endpoint's own default — so an absent value never
 * labels a line as a frame the run was not computed in.
 */
export const frameAbbrev = (frameOfReference) =>
  frameOfReference === 'Heliocentric' ? 'Helio' : 'Geo';

/**
 * `p1-degrees-p2 (Frame)` — the identity of one study run, on the line it drew.
 *
 * The frame is part of it because the same pair and angle produce different dates geocentrically
 * and heliocentrically. Two runs land on one chart, and without the suffix there is nothing on
 * screen to tell them apart.
 */
export const longitudeLineLabel = (planet1, degrees, planet2, frameOfReference) =>
  `${planet1}-${degrees}-${planet2} (${frameAbbrev(frameOfReference)})`;
